<template lang="html">
    <div class="container" id="text-page">
      <h1 class="mb-3 page-title">Preguntas frecuentes de los Afiliados</h1>

      <!-- <div v-html="row"></div> -->

      <h5>¿Qué necesito para vender en ANLESA?</h5>
      <p>
        Debes registrarte como vendedor afiliado, proporcionar tus datos fiscales, y cumplir con las políticas de calidad y transparencia.
      </p>

      <br />
      <h5>¿ANLESA cobra alguna comisión por venta?</h5>
      <p>
        Sí, ANLESA cobra una comisión sobre cada venta realizada. Los porcentajes específicos se indican durante el proceso de afiliación.
      </p>

      <br />
      <h5>¿Quién se encarga del envío de los productos?</h5>
      <p>
        Cada vendedor es responsable de gestionar sus envíos y cumplir con los tiempos y condiciones que publica.
      </p>

      <br />
      <h5>¿Cómo se manejan las devoluciones?</h5>
      <p>
        Tú defines tu propia política de devoluciones. Es importante publicarla claramente y cumplir con ella para evitar conflictos.
      </p>

      <br />
      <h5>¿ANLESA me ayuda a promocionar mis productos?</h5>
      <p>
        Sí, ANLESA realiza campañas generales de promoción del marketplace. También puedes acceder a servicios adicionales de visibilidad si lo deseas.
      </p>

    </div>
  </template>

  <script>
  export default {
    data(){
      return{
        row:null,
      }
    },

    methods: {
      getData: function(){
        axios.get(tools.url('/api/faqs_users')).then((response)=>{
          this.row = response.data.body;
        }).catch((error)=>{
        })
      },
    },

    mounted(){
        this.getData();
    },
  }
  </script>
